/* Catalogue control/runtime adapter. Source panel motion/keyboard semantics;
   native Shopify ordering/search + complete paginated PUBLIC_READ facet data.
   Local metadata filtering is fenced to unpublished205457097035 only. */
(() => {
  if (customElements.get('miniami-catalogue-controls')) return;
  // Display families only: members remain exact, separately stored native labels.
  // Fold explicit shade qualifiers, never ambiguous hues (e.g. Red is not Pink).
  const colourFamilies = [
    ['Pink', '#FF1759', ['Pink', 'Hot pink', 'Light pink', 'Dark pink']],
    ['Blush', '#FFA2AF', ['Blush']],
    ['Orange', '#FF5B00', ['Orange', 'Dark orange', 'Dark Orange', 'Light Orange', 'Light orange']],
    ['Yellow', '#FFD43B', ['Yellow', 'Light yellow']],
    ['Green', '#8BC34A', ['Green', 'Light green', 'Dark green', 'Light Green']],
    ['Blue', '#4FA8D8', ['Blue', 'Light blue']],
    ['White', '#FCFCFC', ['White']],
    ['Black', '#17171A', ['Black']],
    ['Brown', '#8C5B3F', ['Brown', 'Light brown', 'Dark brown']],
    ['Beige', '#D6C3A5', ['Beige']],
    ['Red', '#D93636', ['Red', 'Light red']],
    ['Coral', '#F47C6B', ['Coral']],
    ['Salmon', '#FA8072', ['Salmon']],
    ['Teal', '#268C8C', ['Teal', 'Dark teal']],
    ['Purple', '#8A6F97', ['Smoky purple', 'Purple']],
    ['Grey', '#888888', ['Dark grey', 'Light grey']],
    ['Yellow-orange', '#F3AE25', ['Yellow-orange']],
  ];
  // Existing shopify--skill-level objects, qualified read-only for this store.
  // A zero count stays disabled: the presence of an object is not an assessment.
  const skillOptions = [
    { label: 'Beginner', value: 'gid://shopify/Metaobject/244907606347' },
    { label: 'Intermediate', value: 'gid://shopify/Metaobject/244907639115' },
    { label: 'Advanced', value: 'gid://shopify/Metaobject/288538788171' },
  ];
  const sizeOptions = ['Mini · under 4 cm', '4–7 cm', 'Over 7 cm'];
  class MiniamiCatalogueControls extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal, capture: true };
      this.details = this.querySelector('.miniami-catalogue-filter-drawer');
      this.panel = this.querySelector('.miniami-catalogue-filter-panel');
      this.trigger = this.querySelector('.miniami-catalogue-filter-trigger');
      this.scrim = this.querySelector('.miniami-catalogue-controls__scrim');
      this.addEventListener('click', (event) => {
        const sortOption = event.target.closest('[data-catalogue-sort-value]');
        if (sortOption) {
          event.preventDefault();
          const select = this.querySelector('#SortBy');
          select.value = sortOption.dataset.catalogueSortValue;
          this.setSortOpen(false, true);
          select.dispatchEvent(new Event('input', { bubbles: true }));
          this.restoreSortFocus = true;
          select.closest('facet-filters-form')?.flushCatalogueSubmit();
        } else if (event.target.closest('.miniami-catalogue-sort-trigger')) {
          event.preventDefault();
          this.setSortOpen(!this.querySelector('[data-catalogue-sort-popup]')?.open);
        } else if (event.target.closest('[data-catalogue-retry]')) {
          event.preventDefault();
          const form = this.querySelector('#FacetFiltersForm');
          form?.closest('facet-filters-form')?.onSubmitForm(new URLSearchParams(new FormData(form)).toString(), { target: form });
        } else if (event.target.closest('.miniami-catalogue-filter-trigger')) {
          event.preventDefault();
          this.setSortOpen(false);
          this.setOpen(!this.details.open || this.closing);
        } else if (event.target.closest('[data-miniami-catalogue-filter-close], [data-miniami-catalogue-dismiss], [data-miniami-catalogue-filter-apply]')) {
          event.preventDefault();
          if (event.target.closest('[data-miniami-catalogue-filter-apply]')) {
            const form = this.querySelector('#FacetFiltersForm');
            const nativeForm = form?.closest('facet-filters-form');
            if (this.failed) nativeForm?.onSubmitForm(new URLSearchParams(new FormData(form)).toString(), { target: form });
            else nativeForm?.flushCatalogueSubmit();
          }
          this.setOpen(false);
        }
      }, options);
      this.addEventListener('input', () => this.syncSort(), options);
      this.addEventListener('change', () => this.syncSort(), options);
      this.addEventListener('keyup', (event) => {
        if (event.key !== 'Escape' || !this.details?.open) return;
        event.preventDefault();
        event.stopPropagation();
        const inner = event.target.closest('details[open]');
        if (inner && inner !== this.details) {
          // Delegate the nearest native disclosure once, before Dawn's two listeners.
          if (typeof onKeyUpEscape === 'function') onKeyUpEscape(event);
        } else this.setOpen(false);
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.target.closest('[data-catalogue-sort-popup]')) {
          this.onSortKey(event);
          return;
        }
        if (event.key !== 'Tab' || !this.details?.open || this.closing) return;
        const items = [...this.panel.querySelectorAll('button, a[href], input:not([disabled]), select, summary, [tabindex="0"]')]
          .filter((element) => !element.disabled && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
        if (!items.length) return;
        const index = items.indexOf(document.activeElement);
        // Own all dialog Tab moves, including WebKit's buttons-skipping default.
        event.preventDefault();
        const next = index < 0 ? (event.shiftKey ? items.length - 1 : 0)
          : (index + (event.shiftKey ? -1 : 1) + items.length) % items.length;
        items[next].focus();
      }, options);
      this.observer = new MutationObserver(() => this.syncSort());
      this.observer.observe(this, { childList: true, subtree: true });
      this.setAttribute('data-ready', '');
      document.addEventListener('pointerdown', (event) => {
        if (!event.target.closest('.miniami-catalogue-source-sort')) this.setSortOpen(false);
      }, { signal: this.controller.signal });
      document.addEventListener('focusin', (event) => {
        // Native facet navigation moves WebKit focus to MainContent after Clear.
        // Keep an already-open filter dialog usable without trapping other modals.
        if (this.details?.open && !this.closing && !this.panel.contains(event.target) && event.target !== this.trigger) {
          this.panel.querySelector('[data-miniami-catalogue-filter-close]')?.focus({ preventScroll: true });
        }
      }, { signal: this.controller.signal });
      this.syncSort();
      // Old page-number/relevance bookmarks must not strand part of the catalog
      // or label a server relevance response as Featured. Re-query natively.
      const lifecycle = this.controller;
      customElements.whenDefined('facet-filters-form').then(() => {
        if (this.controller !== lifecycle) return;
        // This script precedes deferred facets.js on real collection/search
        // routes. Wait for its element upgrade before using the native methods.
        this.initDraftFacets();
        this.normalizeRoute();
      });
    }
    initDraftFacets() {
      if (Number(window.Shopify?.theme?.id) !== 205457097035 || !['main','published','unpublished'].includes(window.Shopify.theme.role)) return;
      const section = this.closest('.shopify-section');
      const payload = section?.querySelector('[data-miniami-catalogue-page]');
      if (!payload) return;
      try {
        const data = JSON.parse(payload.textContent);
        if (data.version !== 1 || Number(data.theme) !== 205457097035 || !['main','published','unpublished'].includes(data.themeRole)) return;
        this.draftSection = data.section;
        this.nativeBundleRoute = data.route === '/collections/beading-patterns-bundles';
        this.initialBundlePage = this.nativeBundleRoute ? data : null;
        this.draftGridClass = document.querySelector('#product-grid ul.product-grid, ul#product-grid')?.className || 'grid product-grid grid--1-col-tablet-down grid--3-col-desktop';
        this.setAttribute('data-draft-facets', '');
        // Own draft input immediately; never let Dawn's 800ms callback re-read
        // a checkbox which an older response has since reset. Native checkbox
        // activation (pointer or Space) is untouched; only submission is owned.
        this.addEventListener('input', (event) => {
          const input = event.target;
          if (!input.matches('[data-draft-color-members], #SortBy') && !this.draftParams().includes(input.name)) return;
          event.stopImmediatePropagation();
          const query = new URLSearchParams(new FormData(this.querySelector('#FacetFiltersForm')));
          if (input.hasAttribute('data-draft-color-members')) {
            const selected = new Set(query.getAll(this.draftParams()[1]));
            JSON.parse(input.dataset.draftColorMembers).forEach((value) => input.checked ? selected.add(value) : selected.delete(value));
            query.delete(this.draftParams()[1]);
            selected.forEach((value) => query.append(this.draftParams()[1], value));
          }
          this.renderDraftResults(query.toString());
        }, { signal: this.controller.signal, capture: true });
        this.addEventListener('submit', (event) => {
          if (event.target.id !== 'FacetFiltersForm') return;
          event.preventDefault(); event.stopImmediatePropagation();
          this.renderDraftResults(new URLSearchParams(new FormData(event.target)).toString());
        }, { signal: this.controller.signal, capture: true });
        this.addEventListener('click', (event) => {
          const remove = event.target.closest('[data-draft-remove], [data-draft-reset]');
          if (!remove) return;
          event.preventDefault(); event.stopImmediatePropagation();
          // Include the current form selection, even if a native sort is pending.
          const query = new URLSearchParams(new FormData(this.querySelector('#FacetFiltersForm')));
          const hadFocus = remove === document.activeElement;
          const nextIndex = [...this.querySelectorAll('[data-draft-remove]')].indexOf(remove);
          if (remove.hasAttribute('data-draft-reset')) {
            this.draftParams().forEach((param) => query.delete(param));
            // Clear legacy native filters too; keep search, currency and sort.
            [...query.keys()].filter((key) => key.startsWith('filter.')).forEach((key) => query.delete(key));
          } else {
            const key = remove.dataset.draftParam;
            const removed = JSON.parse(remove.dataset.draftValues || JSON.stringify([remove.dataset.draftValue]));
            const values = query.getAll(key).filter((value) => !removed.includes(value));
            query.delete(key); values.forEach((value) => query.append(key, value));
          }
          this.renderDraftResults(query.toString());
          if (hadFocus && !remove.isConnected) {
            (this.querySelectorAll('[data-draft-remove]')[Math.max(0, nextIndex)] || this.trigger)?.focus({ preventScroll: true });
          }
        }, { signal: this.controller.signal, capture: true });
        this.querySelector('.miniami-catalogue-filter-panel__clear a')?.setAttribute('data-draft-reset', '');
        this.renderDraftResults(location.search, false);
      } catch (error) { this.setLoading(false, error); }
    }
    draftParams() {
      return ['filter.p.m.shopify.skill-level', 'filter.p.m.custom.colors', 'filter.p.m.custom.finished_size_band'];
    }
    draftMatches(item, query, ignoreParam) {
      const fields = [item.skills?.map((skill) => skill.value) || [], item.colors || [], item.size ? [item.size] : []];
      return this.draftParams().every((param, index) => {
        const selected = query.getAll(param);
        return param === ignoreParam || !selected.length || (item.type === 'product' && selected.some((value) => fields[index].includes(value)));
      });
    }
    previewDraftCount() {
      if (!this.draftItems) return;
      const form = this.querySelector('#FacetFiltersForm');
      const query = new URLSearchParams(new FormData(form));
      const count = this.draftItems.filter((item) => this.draftMatches(item, query)).length;
      const label = this.querySelector('[data-miniami-catalogue-show-results]');
      if (label && !this.hasAttribute('aria-busy')) label.textContent = `Show ${count} ${location.pathname.includes('/search') ? (count === 1 ? 'result' : 'results') : (count === 1 ? 'pattern' : 'patterns')}`;
    }
    syncDraftSelection(query) {
      const params = this.draftParams();
      const form = this.querySelector('#FacetFiltersForm');
      form.querySelectorAll('.miniami-catalogue-field input').forEach((input) => {
        input.checked = input.hasAttribute('data-draft-color-members')
          ? JSON.parse(input.dataset.draftColorMembers).some((value) => query.getAll(params[1]).includes(value))
          : query.getAll(input.name).includes(input.value);
      });
      let hidden = form.querySelector('[data-draft-selected-values]');
      if (!hidden) { hidden = document.createElement('div'); hidden.hidden = true; hidden.setAttribute('data-draft-selected-values', ''); form.append(hidden); }
      hidden.replaceChildren();
      params.forEach((param) => query.getAll(param).forEach((value) => {
        // Colours serialize the literal members, not a fabricated family field.
        // Legacy/unknown bookmarks remain removable, never a visible fake option.
        if ([...form.querySelectorAll('.miniami-catalogue-field input[name]')].some((input) => input.name === param && input.value === value)) return;
        const input = document.createElement('input'); input.type = 'hidden'; input.name = param; input.value = value; hidden.append(input);
      }));
    }
    syncDraftFields(query) {
      const params = this.draftParams();
      const kinds = ['skill', 'colors', 'size'];
      const nativeColours = new Set(this.draftItems.flatMap((item) => item.colors || []));
      const nativeSkills = this.draftItems.flatMap((item) => item.skills || []);
      const optionsByKind = [
        skillOptions.map((skill) => ({ ...skill, value: nativeSkills.find((value) => value.label === skill.label)?.value || skill.value })),
        colourFamilies.map(([label, color, members]) => ({ label, value: label, color, members: members.filter((value) => nativeColours.has(value)) })).filter((option) => option.members.length),
        sizeOptions.map((value) => ({ value, label: value })),
      ];
      params.forEach((param, index) => {
        const field = this.querySelector(`[data-index="catalogue-${kinds[index]}"]`);
        const target = field?.querySelector('.miniami-catalogue-field__values');
        if (!target) return;
        const options = optionsByKind[index];
        if (!target.hasAttribute('data-draft-bound')) { target.replaceChildren(); target.setAttribute('data-draft-bound', ''); }
        [...target.querySelectorAll('label')].forEach((label) => { if (!options.some((option) => option.value === label.querySelector('input')?.value)) label.remove(); });
        options.forEach((option) => {
          const { label: labelText, value } = option;
          let label = [...target.querySelectorAll('label')].find((node) => node.querySelector('input')?.value === value);
          if (!label) {
            label = document.createElement('label');
            label.className = 'miniami-catalogue-field__option' + (index === 1 ? ' miniami-catalogue-field__option--color' : '');
            const input = document.createElement('input'); input.type = 'checkbox'; input.value = value;
            if (index !== 1) input.name = param;
            input.id = `Filter-draft-${kinds[index]}-${this.draftSection}-${encodeURIComponent(value)}`;
            label.htmlFor = input.id; label.append(input);
            const visual = document.createElement('span');
            if (index === 1) {
              visual.className = 'miniami-catalogue-color-dot'; visual.setAttribute('aria-hidden', 'true');
              visual.style.setProperty('--catalogue-dot', option.color);
            } else { visual.className = 'miniami-catalogue-option__visual'; visual.textContent = labelText; }
            label.append(visual); target.append(label);
          }
          const input = label.querySelector('input');
          if (index === 1) input.dataset.draftColorMembers = JSON.stringify(option.members);
          const count = this.draftItems.filter((item) => {
            if (!this.draftMatches(item, query, param)) return false;
            return index === 0 ? item.skills?.some((skill) => skill.value === value) : index === 1 ? option.members.some((member) => item.colors?.includes(member)) : item.size === value;
          }).length;
          const selected = index === 1 ? option.members.some((member) => query.getAll(param).includes(member)) : query.getAll(param).includes(value);
          input.disabled = count === 0 && !selected;
          input.setAttribute('aria-label', `${labelText} · ${count} matching ${count === 1 ? 'product' : 'products'}`);
          label.classList.toggle('disabled', input.disabled); label.dataset.matchCount = String(count);
        });
        // Factual coverage belongs in private qualification, not customer UI.
        target.querySelectorAll('[data-draft-coverage], [data-catalogue-staged]').forEach((note) => note.remove());
        field.querySelector('fieldset')?.removeAttribute('aria-describedby');
      });
      this.syncDraftSelection(query);
    }
    syncDraftContext(query, source) {
      const form = this.querySelector('#FacetFiltersForm');
      let preserved = form.querySelector('[data-catalogue-preserved-filters]');
      if (!preserved) { preserved = document.createElement('div'); preserved.hidden = true; preserved.setAttribute('data-catalogue-preserved-filters', ''); form.append(preserved); }
      preserved.replaceChildren();
      let context = form.querySelector('[data-draft-context]');
      if (!context) { context = document.createElement('div'); context.hidden = true; context.setAttribute('data-draft-context', ''); form.append(context); }
      context.replaceChildren();
      query.forEach((value, key) => {
        if (this.draftParams().includes(key) || ['q', 'sort_by', 'page', 'section_id'].includes(key)) return;
        if (key.startsWith('filter.')) {
          const input = document.createElement('input'); input.type = 'hidden'; input.name = key; input.value = value; preserved.append(input);
        } else if (!form.querySelector(`input[name="${CSS.escape(key)}"]`)) {
          const input = document.createElement('input'); input.type = 'hidden'; input.name = key; input.value = value; context.append(input);
        }
      });
      const nativePills = source.querySelector('.active-facets-desktop');
      const targetPills = this.querySelector('.active-facets-desktop');
      if (nativePills && targetPills) targetPills.innerHTML = nativePills.innerHTML;
    }
    syncDraftPills(query) {
      let pills = this.querySelector('[data-draft-pills]');
      if (!pills) {
        pills = document.createElement('div'); pills.className = 'active-facets miniami-catalogue-active-facets'; pills.setAttribute('data-draft-pills', '');
        this.querySelector('.miniami-catalogue-active-facets')?.before(pills);
      }
      const selections = [];
      this.draftParams().forEach((param, index) => {
        const selected = [...new Set(query.getAll(param))];
        if (index === 1) {
          const handled = new Set();
          colourFamilies.forEach(([label, color, members]) => {
            const values = selected.filter((value) => members.includes(value));
            if (!values.length) return;
            values.forEach((value) => handled.add(value));
            // A bookmarked single shade stays literal; a whole chosen family is one chip.
            const available = members.filter((value) => this.draftItems.some((item) => item.colors?.includes(value)));
            selections.push({ param, values, color, label: available.length === values.length && values.length > 1 ? label : values.join(', ') });
          });
          selected.filter((value) => !handled.has(value)).forEach((value) => selections.push({ param, values: [value], label: value }));
        } else selected.forEach((value) => selections.push({ param, values: [value], label: index === 0 ? this.draftItems.flatMap((item) => item.skills || []).find((skill) => skill.value === value)?.label || skillOptions.find((skill) => skill.value === value)?.label || 'Unavailable selection' : value }));
      });
      // Reuse connected chips: preserve natural keyboard focus during re-renders.
      const keys = selections.map(({ param, values }) => JSON.stringify([param, values]));
      [...pills.children].forEach((button) => { if (!keys.includes(button.dataset.draftKey)) button.remove(); });
      selections.forEach(({ param, values, label, color }, index) => {
        const key = keys[index];
        let button = [...pills.children].find((node) => node.dataset.draftKey === key);
        if (!button) {
          button = document.createElement('button'); button.type = 'button'; button.className = 'active-facets__button-inner button button--tertiary';
          const visual = document.createElement('span'); visual.className = 'miniami-catalogue-chip__visual'; visual.setAttribute('aria-hidden', 'true');
          if (param === this.draftParams()[1]) {
            const dot = document.createElement('span'); dot.className = 'miniami-catalogue-chip__dot';
            dot.style.setProperty('--catalogue-dot', color || '#C9C9C4'); visual.append(dot, document.createTextNode('×'));
          } else visual.textContent = `${label} ×`;
          button.append(visual);
          button.setAttribute('aria-label', `Remove ${label} filter`); button.setAttribute('data-draft-remove', '');
          button.dataset.draftParam = param; button.dataset.draftValue = values[0]; button.dataset.draftValues = JSON.stringify(values); button.dataset.draftKey = key; pills.append(button);
        }
      });
      pills.dataset.activeFilterCount = String(selections.length); pills.hidden = selections.length === 0;
      // Preserve native legacy filter pills without a second Clear all.
      this.querySelector('.active-facets-desktop .active-facets__button-wrapper')?.setAttribute('hidden', '');
    }
    async renderDraftResults(searchParams, updateURLHash = true) {
      if (!this.hasAttribute('data-draft-facets') || !this.isConnected) return;
      const query = new URLSearchParams(searchParams);
      query.delete('page'); query.delete('section_id');
      const normalized = this.querySelector('[data-catalogue-normalize-sort]');
      if (normalized && !location.pathname.includes('/search')) query.set('sort_by', this.querySelector('#SortBy').value || normalized.dataset.catalogueNormalizeSort);
      this.draftRequested = query.toString();
      this.querySelector('#FacetFiltersForm')?.closest('facet-filters-form')?.cancelCatalogueSubmit();
      this.draftRequest?.abort();
      if (this.draftItems) {
        this.syncDraftSelection(query);
        this.syncDraftPills(query); // Removal paints immediately, even during a new native sort.
      }
      const request = new AbortController(); this.draftRequest = request;
      let timedOut = false;
      const deadline = setTimeout(() => { timedOut = true; request.abort(); }, 20000);
      document.querySelectorAll('miniami-catalogue-more').forEach((loader) => loader.cancel?.());
      this.setLoading(true);
      const transport = new URLSearchParams(query);
      // The default collection order and its explicit manual bookmark are the
      // same native query. Canonicalise the transport, not the customer's URL.
      if (!transport.has('sort_by') && !location.pathname.includes('/search')) {
        transport.set('sort_by', this.querySelector('#SortBy').value);
      }
      this.draftParams().forEach((param) => transport.delete(param));
      transport.set('section_id', this.draftSection);
      let url = new URL(location.pathname, location.origin); url.search = transport.toString();
      const transportKey = url.href;
      const items = [], seen = new Set(), visited = new Set();
      let firstDocument, total, expectedPages, currency, page = 0;
      // Reuse only the current complete, identity-checked native result set for
      // metadata-only toggles/removal. Sort/search/legacy facets/market changes
      // have a different transport key and still require a fresh native response.
      // A complete native bundles SSR page already has the correct Shopify
      // order, prices and gallery markup. Adopt it, without fetching/repainting.
      // Partial pages/bookmarks and active metadata still use the normal path.
      const initial = this.initialBundlePage;
      this.initialBundlePage = null;
      const preserveInitialGrid = !updateURLHash && initial?.page === 1 && initial.pages === 1
        && initial.items.length === initial.total && !new URLSearchParams(location.search).has('page')
        && !this.draftParams().some((param) => query.has(param))
        && initial.sort === transport.get('sort_by');
      const cachedSource = this.draftSources?.get(transportKey) || (preserveInitialGrid
        ? { firstDocument: document.cloneNode(true), items: initial.items, total: initial.total, expectedPages: 1, currency: initial.currency, page: 1 }
        : null);
      if (cachedSource) {
        ({ firstDocument, total, expectedPages, currency, page } = cachedSource);
        items.push(...cachedSource.items);
        url = null;
      }
      try {
        while (url) {
          if (url.origin !== location.origin || url.pathname !== location.pathname || visited.has(url.href)) throw new Error('Invalid catalogue continuation');
          visited.add(url.href);
          const response = await fetch(url, { signal: request.signal, credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) throw new Error(`Catalogue HTTP ${response.status}`);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const node = doc.querySelector('[data-miniami-catalogue-page]');
          if (!node) throw new Error('Catalogue data missing');
          const data = JSON.parse(node.textContent);
          if (data.version !== 1 || Number(data.theme) !== 205457097035 || !['main','published','unpublished'].includes(data.themeRole) || data.section !== this.draftSection || data.route !== location.pathname || !Array.isArray(data.items) || data.page !== page + 1) throw new Error('Catalogue identity/page mismatch');
          if (!firstDocument) { firstDocument = doc; total = data.total; expectedPages = data.pages; currency = data.currency; }
          if (!Number.isInteger(total) || total < 0 || data.total !== total || data.pages !== expectedPages || data.currency !== currency) throw new Error('Catalogue changed during pagination');
          page = data.page;
          for (const item of data.items) {
            const key = `${item.type}:${item.id}`;
            if (!item.id || seen.has(key) || typeof item.html !== 'string' || !Array.isArray(item.skills) || (item.colors != null && !Array.isArray(item.colors))) throw new Error('Invalid/duplicate catalogue item');
            seen.add(key); items.push(item);
          }
          if (data.next) { url = new URL(data.next, location.origin); this.draftParams().forEach((param) => url.searchParams.delete(param)); url.searchParams.set('section_id', this.draftSection); }
          else url = null;
        }
        if (items.length !== total || (total > 0 && page !== expectedPages)) throw new Error('Incomplete catalogue');
        if (!this.isConnected || this.draftRequest !== request) return;
        const sourceContainer = firstDocument.querySelector('#ProductGridContainer');
        const targetContainer = document.querySelector('#ProductGridContainer');
        if (!sourceContainer || !targetContainer) throw new Error('Catalogue grid missing');
        const matching = items.filter((item) => this.draftMatches(item, query));
        const hasMetadata = this.draftParams().some((param) => query.has(param));
        let source = cachedSource;
        if (source?.key !== transportKey) {
          // Parse the supplied cards once per native response, never recompute
          // their money/markup. Moving keyed nodes makes metadata removal cheap.
          const template = sourceContainer.cloneNode(true);
          template.querySelector('ul#product-grid, #product-grid ul.product-grid')?.replaceChildren();
          const cards = new Map(items.map((item) => {
            if (preserveInitialGrid) {
              const card = [...targetContainer.querySelectorAll('ul#product-grid > li')]
                .find((node) => node.querySelector('[data-product-id]')?.dataset.productId === item.id);
              if (!card) throw new Error('Missing native bundle card');
              return [`${item.type}:${item.id}`, card];
            }
            const fragment = document.createElement('template'); fragment.innerHTML = item.html;
            const card = fragment.content.firstElementChild;
            if (fragment.content.children.length !== 1 || card?.tagName !== 'LI' || card.dataset.miniamiResultId !== item.id) throw new Error('Invalid catalogue card');
            return [`${item.type}:${item.id}`, card];
          }));
          source = { key: transportKey, items, firstDocument, total, expectedPages, currency, page, template, cards };
        }
        const container = source.template.cloneNode(true);
        const lead = container.querySelector('.miniami-bundles-lead');
        if (hasMetadata) lead?.remove();
        const matchedIds = new Set(matching.map((item) => item.id));
        container.querySelectorAll('[data-bundle-product-id]').forEach((element) => {
          if (!matchedIds.has(element.dataset.bundleProductId)) element.closest('li')?.remove();
        });
        if (lead && !lead.querySelector('[data-bundle-product-id]')) lead.remove();
        const promoted = new Set([...container.querySelectorAll('[data-bundle-product-id]')].map((element) => element.dataset.bundleProductId));
        // Prepare only this section's CollectionPage before moving cached cards.
        // A failed/stale request must leave the previous grid AND schema intact.
        const schemaTarget = this.closest('.shopify-section')?.querySelector('[data-miniami-catalogue-schema]');
        let committedSchema;
        if (schemaTarget) {
          const schemaSource = firstDocument.querySelector('[data-miniami-catalogue-schema]');
          if (schemaTarget.dataset.miniamiCatalogueSchema !== this.draftSection || schemaSource?.dataset.miniamiCatalogueSchema !== this.draftSection) throw new Error('Catalogue schema identity mismatch');
          const schema = JSON.parse(schemaSource.textContent);
          if (schema['@type'] !== 'CollectionPage') throw new Error('Invalid catalogue schema');
          const byId = new Map(matching.map((item) => [item.id, item]));
          const visible = [...promoted].map((id) => byId.get(id)).concat(matching.filter((item) => !promoted.has(item.id)));
          schema.mainEntity = {
            '@type': 'ItemList', numberOfItems: visible.length,
            itemListElement: visible.map((item, index) => {
              if (!item || typeof item.name !== 'string' || !item.name.trim() || typeof item.url !== 'string') throw new Error('Missing native catalogue identity');
              const url = new URL(item.url, location.origin);
              if (url.origin !== location.origin) throw new Error('Foreign catalogue product URL');
              url.search = ''; url.hash = '';
              return { '@type': 'ListItem', position: index + 1, url: url.href, name: item.name };
            }),
          };
          committedSchema = JSON.stringify(schema).replace(/</g, '\\u003c');
        } else if (!location.pathname.includes('/search')) throw new Error('Catalogue schema missing');
        let grid = container.querySelector('ul#product-grid, #product-grid ul.product-grid');
        if (!grid) {
          const old = container.querySelector('#product-grid');
          const wrapper = document.createElement('div'); wrapper.className = 'collection page-width';
          grid = document.createElement('ul'); grid.id = 'product-grid'; grid.dataset.id = this.draftSection; grid.className = this.draftGridClass;
          wrapper.append(grid); if (old) old.replaceWith(wrapper); else container.append(wrapper);
        }
        if (!preserveInitialGrid) grid.replaceChildren(...matching.filter((item) => !promoted.has(item.id)).map((item) => source.cards.get(`${item.type}:${item.id}`)));
        container.querySelectorAll('miniami-catalogue-more, .pagination-wrapper, [data-draft-empty]').forEach((node) => node.remove());
        if (!matching.length) {
          const empty = document.createElement('p'); empty.className = 'miniami-catalogue-field__note'; empty.setAttribute('data-draft-empty', ''); empty.setAttribute('role', 'status'); empty.textContent = 'No matching results. Try fewer filters or clear all.'; grid.before(empty);
        }
        if (!preserveInitialGrid) targetContainer.replaceChildren(...container.childNodes);
        if (schemaTarget) schemaTarget.textContent = committedSchema;
        this.draftSource = source;
        // Keep a bounded per-query cache. Back/forward and revisiting an already
        // qualified native sort do not require a redundant GET or money rebuild.
        this.draftSources ||= new Map();
        this.draftSources.delete(transportKey);
        this.draftSources.set(transportKey, source);
        if (this.draftSources.size > 6) this.draftSources.delete(this.draftSources.keys().next().value);
        this.draftItems = items;
        const select = this.querySelector('#SortBy');
        const nativeSelect = firstDocument.querySelector('#SortBy');
        if (select && nativeSelect) select.value = nativeSelect.value;
        this.querySelectorAll('[data-catalogue-sort-value]').forEach((option) => option.setAttribute('aria-selected', String(option.dataset.catalogueSortValue === select?.value)));
        this.syncDraftContext(query, firstDocument);
        this.syncDraftFields(query); this.syncDraftPills(query);
        const count = matching.length;
        document.querySelectorAll('#ProductCount, #ProductCountDesktop, [data-miniami-catalogue-title-count]').forEach((node) => { node.textContent = `${count} ${location.pathname.includes('/search') ? (count === 1 ? 'result' : 'results') : (count === 1 ? 'product' : 'products')}`; node.dataset.productCount = String(count); });
        this.dataset.draftResultCount = String(count); this.dataset.draftTotal = String(total); this.dataset.draftPages = String(page);
        this.removeAttribute('data-draft-failed');
        const label = this.querySelector('[data-miniami-catalogue-show-results]');
        if (label) label.textContent = `Show ${count} ${location.pathname.includes('/search') ? (count === 1 ? 'result' : 'results') : (count === 1 ? 'pattern' : 'patterns')}`;
        this.querySelector('[data-catalogue-normalize-sort]')?.removeAttribute('data-catalogue-normalize-sort');
        if (updateURLHash) history.pushState({ searchParams: query.toString() }, '', `${location.pathname}${query.size ? '?' + query : ''}`);
        else if (new URLSearchParams(location.search).toString() !== query.toString()) history.replaceState({ searchParams: query.toString() }, '', `${location.pathname}${query.size ? '?' + query : ''}`);
        if (typeof FacetFiltersForm !== 'undefined') FacetFiltersForm.searchParamsPrev = query.toString();
        this.setLoading(false);
      } catch (error) {
        if (this.draftRequest !== request || (!timedOut && error.name === 'AbortError')) return;
        this.setAttribute('data-draft-failed', ''); this.setLoading(false, error);
      } finally { clearTimeout(deadline); if (this.draftRequest === request) this.draftRequest = null; }
    }
    normalizeRoute() {
      if (this.hasAttribute('data-draft-facets')) return;
      if (!this.isConnected || this.hasAttribute('aria-busy') || this.failed) return;
      const form = this.querySelector('#FacetFiltersForm');
      const nativeForm = form?.closest('facet-filters-form');
      if (typeof nativeForm?.onSubmitForm !== 'function') return;
      const query = new URLSearchParams(location.search);
      const normalizeSort = this.querySelector('[data-catalogue-normalize-sort]');
      const normalizePage = Number(query.get('page')) > 1;
      if (!normalizeSort && !normalizePage) return;
      if (normalizeSort) query.set('sort_by', this.querySelector('#SortBy').value || normalizeSort.dataset.catalogueNormalizeSort);
      if (normalizePage) query.delete('page');
      nativeForm.onSubmitForm(query.toString(), { target: form });
    }
    syncSort() {
      const select = this.querySelector('#SortBy');
      const label = this.querySelector('[data-miniami-catalogue-selected-sort]');
      const text = select?.selectedOptions[0]?.textContent.trim();
      if (label && text && label.textContent !== text) label.textContent = text;
      if (this.restoreSortFocus && !this.hasAttribute('aria-busy')) {
        this.restoreSortFocus = false;
        this.querySelector('.miniami-catalogue-sort-trigger')?.focus({ preventScroll: true });
      }
      this.normalizeRoute();
    }
    setLoading(loading, error) {
      if (loading) this.setAttribute('aria-busy', 'true');
      else this.removeAttribute('aria-busy');
      this.failed = Boolean(error);
      const label = this.querySelector('[data-miniami-catalogue-show-results]');
      if (label && loading) {
        if (label.textContent !== 'Updating patterns…') this.lastShowLabel = label.textContent;
        label.textContent = 'Updating patterns…';
      } else if (label && label.textContent === 'Updating patterns…') label.textContent = this.lastShowLabel || '';
      const apply = this.querySelector('[data-miniami-catalogue-filter-apply]');
      if (apply) apply.disabled = loading;
      const message = this.querySelector('[data-catalogue-error]');
      if (message) message.hidden = !error;
      const toolbarError = this.querySelector('[data-catalogue-toolbar-error]');
      if (toolbarError) toolbarError.hidden = !error;
      this.syncSort();
    }
    setSortOpen(open, restore = false) {
      const popup = this.querySelector('[data-catalogue-sort-popup]');
      if (!popup) return;
      popup.open = open;
      const trigger = popup.querySelector('summary');
      trigger.setAttribute('aria-expanded', String(open));
      const options = [...popup.querySelectorAll('[role="option"]')];
      options.forEach((option) => option.tabIndex = -1);
      if (open) {
        popup.style.setProperty('--catalogue-sort-space', `${Math.max(44, innerHeight - trigger.getBoundingClientRect().bottom - 18)}px`);
        const selected = options.find((option) => option.getAttribute('aria-selected') === 'true') || options[0];
        if (selected) { selected.tabIndex = 0; selected.focus(); }
      } else if (restore) trigger.focus({ preventScroll: true });
    }
    onSortKey(event) {
      const popup = this.querySelector('[data-catalogue-sort-popup]');
      if (event.key === 'Escape') {
        event.preventDefault(); event.stopPropagation();
        this.setSortOpen(false, true);
        return;
      }
      if (event.key === 'Tab') { this.setSortOpen(false, true); return; }
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (!popup.open) { this.setSortOpen(true); return; }
      const options = [...popup.querySelectorAll('[role="option"]')];
      let index = options.indexOf(document.activeElement);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = options.length - 1;
      else index = (index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
      options.forEach((option, i) => option.tabIndex = i === index ? 0 : -1);
      options[index]?.focus();
      options[index]?.scrollIntoView({ block: 'nearest' });
    }
    setOpen(open) {
      if (!this.details || !this.panel) return;
      const wasOpen = this.details.open;
      const transform = wasOpen ? getComputedStyle(this.panel).transform : `translateX(${this.panel.offsetWidth || 384}px)`;
      const opacity = wasOpen && this.scrim ? getComputedStyle(this.scrim).opacity : '0';
      this.animations?.forEach((animation) => animation.cancel());
      this.animations = [];
      this.closing = !open;
      this.details.open = true; // Keep the surface painted throughout an exit.
      this.trigger.setAttribute('aria-expanded', String(open));
      this.panel.inert = !open;
      if (open) {
        if (this.scrollOverflow === undefined) {
          this.scrollOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
        }
        this.panel.setAttribute('role', 'dialog');
        this.panel.setAttribute('aria-modal', 'true');
        this.panel.querySelector('[data-miniami-catalogue-filter-close]')?.focus({ preventScroll: true });
      }
      const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 400;
      const finish = () => {
        if (open !== !this.closing) return;
        if (!open) {
          if (this.scrollOverflow !== undefined) {
            document.body.style.overflow = this.scrollOverflow;
            this.scrollOverflow = undefined;
          }
          this.details.open = false;
          this.panel.inert = false;
          this.panel.removeAttribute('aria-modal');
          this.panel.setAttribute('role', 'region');
          this.trigger.focus({ preventScroll: true });
        }
      };
      if (!duration) { finish(); return; }
      const settings = { duration, easing: 'cubic-bezier(.4,0,.2,1)' };
      const slide = this.panel.animate([
        { transform: wasOpen ? transform : 'translateX(calc(100% + 24px))' },
        { transform: open ? 'translateX(0)' : 'translateX(calc(100% + 24px))' },
      ], settings);
      this.animations.push(slide);
      if (this.scrim) this.animations.push(this.scrim.animate([{ opacity }, { opacity: open ? 1 : 0 }], settings));
      slide.finished.then(finish).catch(() => {});
    }
    disconnectedCallback() {
      this.draftRequest?.abort();
      this.draftSource = null;
      this.draftSources?.clear();
      if (this.scrollOverflow !== undefined) {
        document.body.style.overflow = this.scrollOverflow;
        this.scrollOverflow = undefined;
      }
      this.draftItems = null;
      this.removeAttribute('data-draft-facets');
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.animations?.forEach((animation) => animation.cancel());
      if (this.details) this.details.open = false;
    }
  }
  customElements.define('miniami-catalogue-controls', MiniamiCatalogueControls);
  // C56: append only native paginated results. A section replacement disconnects
  // and aborts this loader; sorting/filtering always starts a fresh result set.
  class MiniamiCatalogueMore extends HTMLElement {
    connectedCallback() {
      if (document.querySelector('miniami-catalogue-controls[data-draft-facets]')) return;
      if (this.controller) return;
      this.controller = new AbortController();
      this.link = this.querySelector('[data-catalogue-load-more]');
      this.status = this.querySelector('[data-catalogue-load-status]');
      this.visited = new Set();
      this.link?.addEventListener('click', (event) => {
        event.preventDefault(); this.load();
      }, { signal: this.controller.signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting) && !this.failed) this.load();
        }, { rootMargin: '200px' });
        this.observer.observe(this);
      }
    }
    async load() {
      if (this.request || !this.link || this.link.hidden || !this.isConnected) return;
      const url = new URL(this.link.href, location.origin);
      if (url.origin !== location.origin || this.visited.has(url.href)) return;
      url.searchParams.set('section_id', this.dataset.sectionId);
      const request = new AbortController();
      this.request = request;
      this.link.setAttribute('aria-disabled', 'true');
      this.status.textContent = 'Loading patterns…';
      try {
        const response = await fetch(url, { signal: request.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Catalogue page HTTP ${response.status}`);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = html.querySelector('#product-grid');
        if (!source || source.dataset.id !== this.dataset.sectionId) throw new Error('Missing catalogue section');
        if (!this.isConnected || this.request !== request) return;
        const container = this.closest('#ProductGridContainer');
        const grid = container.querySelector('#product-grid');
        const seen = new Set([...container.querySelectorAll('[data-product-id], [data-bundle-product-id]')].map((element) => element.dataset.productId || element.dataset.bundleProductId));
        for (const item of source.querySelectorAll(':scope > li')) {
          const id = item.querySelector('[data-product-id]')?.dataset.productId;
          if (!id || seen.has(id)) continue;
          seen.add(id);
          item.classList.add('scroll-trigger--cancel');
          grid.append(item);
        }
        this.visited.add(this.link.href);
        const next = html.querySelector('miniami-catalogue-more [data-catalogue-load-more]');
        if (next && next.href !== this.link.href) this.link.setAttribute('href', next.getAttribute('href'));
        else { this.link.hidden = true; this.observer?.disconnect(); }
        this.failed = false;
        this.status.textContent = '';
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.failed = true;
          this.status.textContent = 'Couldn’t load more patterns. Use the button to try again.';
        }
      } finally {
        if (this.request === request) {
          this.request = null;
          this.link.removeAttribute('aria-disabled');
        }
      }
    }
    cancel() { this.request?.abort(); this.request = null; this.observer?.disconnect(); }
    disconnectedCallback() { this.cancel(); this.controller?.abort(); this.controller = null; }
  }
  if (!customElements.get('miniami-catalogue-more')) customElements.define('miniami-catalogue-more', MiniamiCatalogueMore);
})();
